import { getAxios } from 'hooks/useAxios';
import { ENDPOINTS } from 'services/endpoints';
import { User } from 'types/user';

const api = getAxios();

export interface IRequestCompanyInformations {
	companyId?: number[];
	timeRange?: number;
	department?: string[];
}

export interface IRequestGoalsInformations {
	companyIds?: number[];
}

export interface ISalesMade {
	order: number;
	month: string;
	totalSales: number;
	profit: number;
}

export interface ICompanyUnitData {
	customers: number;
	profit: number;
	customersPercentageLastYear: number;
	profitPercentageLastYear: number;
	salesMade: ISalesMade[];
}

export type IResponseCompanyInformations = Array<{
	[unitName: string]: ICompanyUnitData;
}>;

export const getCompanyInformations = async ({
	companyId,
	timeRange = 6,
	department,
}: IRequestCompanyInformations): Promise<IResponseCompanyInformations> => {
	const response = await api.post(ENDPOINTS.getCompanyInformations, { companyId, timeRange, department });
	return response.data;
};

export interface IRequestIndicatorsExpanded {
	userId: number;
}

interface IMonthsOfTheYear {
	[key: string]: number;
}

export interface IResponseIndicatorsExpanded {
	[key: string]: IMonthsOfTheYear;
}

export interface IRequestIndicatorsFilteredExpanded {
	months?: number;
	user__id?: number;
	user__company_id__id?: number;
	search?: string;
}

export const getIndicatorsExpanded = async (data: IRequestIndicatorsExpanded): Promise<IResponseIndicatorsExpanded> => {
	const response = await api.post(ENDPOINTS.getIndicatorsExpanded, data);
	return response.data;
};

export const getIndicatorsFilteredExpanded = async (
	params?: IRequestIndicatorsFilteredExpanded,
): Promise<IResponseIndicatorsExpanded> => {
	const response = await api.get(ENDPOINTS.getIndicatorsFilteredExpanded, { params });
	return response.data;
};

export interface IResponseGoals {
	expectative: number;
	percentage: string;
	realSalary: number;
	seller: string;
	quantitySalesExpectative: number;
	quantitySalesReal: number;
}

export type IResponseGoalsInformations = Array<{
	[unitName: string]: IResponseGoals[];
}>;

export const getGoals = async ({ companyIds }: IRequestGoalsInformations): Promise<IResponseGoalsInformations> => {
	const response = await api.post(ENDPOINTS.getGoals, { companyIds });
	return response.data;
};

export interface IResponseServicesChannels {
	seller: User;
	flowSales: {
		flowStore: number;
		sales: number;
		conversion: number;
	};
	pass: {
		flowStorePass: number;
		flowStorePassSales: number;
		conversionFlowStorePass: number;
	};
	calls: {
		calls: number;
		callsAttended: number;
		callsSale: number;
		conversionCalls: number;
	};
	prospection: {
		prospection: number;
		prospectionSale: number;
		conversionProspeccao: number;
	};
	factory: {
		factory: number;
		factorySale: number;
		conversionOficina: number;
	};
	leads: {
		leads: number;
		leadsSale: number;
		conversionLeads: number;
	};
}

export type IResponseServiceInformations = Array<{
	[unitName: string]: IResponseServicesChannels[];
}>;

export const getServicesChannels = async (companyIds: number[] | string): Promise<IResponseServiceInformations> => {
	const idsString = Array.isArray(companyIds) ? companyIds.join(',') : companyIds;

	const response = await api.get(`${ENDPOINTS.getServicesChannels}?company_ids=${idsString}`);
	return response.data;
};
